<template>
  <div class="main-content">
    <nav class="navbar navbar-expand-lg my-2">
      <a
        href="#"
        class="side-menu__icon linear-gradient-color"
        @click="showSidebar"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6h16M4 12h16M4 18h7"
          />
        </svg>
      </a>
      <button
        class="border-0 mx-2 d-lg-none side-menu__icon linear-gradient-color"
        type="button"
        data-toggle="collapse"
        data-target="#collapsibleNavId"
        @click="showMenu = !showMenu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6h16M4 12h16M4 18h7"
          />
        </svg>
      </button>
      <div
        class="collapse navbar-collapse"
        :class="showMenu ? 'show' : ''"
        id="collapsibleNavId"
      >
        <ul class="navbar-nav">
          <li class="nav-item">
            <div class="nav-item_counter">
              <div class="nav-item_counter-img">
                <img src="/weapsmithing/images/material_wood.png" alt="" />
              </div>
              <h6 class="text-black text-center py-2 font-weight-bold" v-if="!loading">
                {{ wsw }}
              </h6>
            </div>
          </li>
          <li class="nav-item">
            <div class="nav-item_counter">
              <div class="nav-item_counter-img">
                <img src="/weapsmithing/images/material_MetalBar.png" alt="" />
              </div>
              <h6 class="text-black text-center py-2 font-weight-bold" v-if="!loading">
                {{ wsm }}
              </h6>
            </div>
          </li>
          <li class="nav-item">
            <div class="nav-item_counter">
              <div class="nav-item_counter-img mt-1">
                <img src="/weapsmithing/images/material_leather.png" alt="" />
              </div>
              <h6 class="text-black text-center py-2 font-weight-bold" v-if="!loading">
                {{ wsl }}
              </h6>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
// import Dropdown from "@/views/Dropdown";
import { reactive } from "vue";
import { mapGetters } from "vuex";

import ApiService from "../services";
export default {
  name: "Navbar",
  computed: {
    ...mapGetters(["mcc", "wsw", "wsl", "wsm", "coins", "loaded"]),
  },
  data() {
    return {
      showMenu: false,
      showSide: false,
      // isOpen: false,
      // showWithdraw: false,
      // showDeposit: false,
      loading: true,
      showHideDropdown: false,
      dropdownItem: [
        {
          title: "Logout",
          link: "#",
        },
      ],
    };
  },

  methods: {
    showSidebar: function () {
      this.showSide = true;
      this.$emit("clicked", false);
    },
    withdrawModal() {
      this.showHideDropdown = false;
      this.showWithdraw = true;
    },
    depositModal() {
      this.showHideDropdown = false;
      this.showDeposit = true;
    },
    isOpen() {
      this.showHideDropdown = this.showHideDropdown ? false : true;
    },
  },
  async created() {
    await this.$store.dispatch("getRecipes");
    await ApiService.getBalance((res) => {
      this.$store.commit("addBalance", res.rows[0]);
      this.loading = false;
    });
  },
  setup() {
    const authentication = reactive({
      user_name: localStorage.getItem("wax_user"),
    });
    return {
      authentication,
    };
  },
};
</script>
<style scoped>
.logo {
  width: 100px;
  float: left;
}
.navbar-nav .dropdown-menu {
  display: block;
}
.dropdown-item {
  font-family: JockeyOne !important;
  color: #fff;
}
.dropdown-item:hover {
  color: #000000;
}
.text-black {
  color: #000000;
}
.mcc-coins {
  width: 52px;
}
</style>